export const balanceTypes = {
    '010': 'Opening Ledger Balance',
    '011': 'Average Opening Ledger MTD',
    '012': 'Average Opening Ledger YTD',
    '015': 'Closing Ledger Balance',
    '020': 'Average Closing Ledger MTD',
    '021': 'Average Closing Ledger - Previous Month',
    '022': 'Aggregate Balance Adjustments',
    '024': 'Average Closing Ledger YTD - Previous Month',
    '025': 'Average Closing Ledger YTD',
    '030': 'Current Ledger Balance',
    '037': 'ACH Net Position',
    '039': 'Opening Available + Total Same-Day ACH DTC Deposit',
    '040': 'Opening Available Balance',
    '041': 'Average Opening Available MTD',
    '042': 'Average Opening Available YTD',
    '043': 'Average Available - Previous Month',
    '044': 'Disbursing Opening Available Balance',
    '045': 'Closing Available Balance',
    '047': 'Mortgage YDP',
    '050': 'Average Closing Available MTD',
    '051': 'Average Closing Available - Last Month',
    '054': 'Average Closing Available YTD - Last Month',
    '055': 'Average Closing Available YTD',
    '056': 'Loan Balance',
    '057': 'Total Investment Position',
    '059': 'Current Available (CRS Suppressed)',
    '060': 'Current Available Balance',
    '061': 'Average Current Available MTD',
    '062': 'Average Current Available YTD',
    '063': 'Total Float',
    '065': 'Target Balance',
    '066': 'Adjusted Opening Balance',
    '067': 'Adjusted Balance MTD',
    '068': 'Adjusted Balance YTD',
    '070': '0 - Day Float',
    '072': '1 Day Float',
    '073': 'Float Adjustment',
    '074': '2 or More Days Float',
    '075': '3 or More Days Float',
    '076': 'Adjustment to Balances',
    '077': 'Average Adjustment to Balances MTD',
    '078': 'Average Adjustment to Balances YTD',
    '079': '4 Days Float',
    '080': '5 Days Float',
    '081': '6 - Day Float',
    '082': 'Average 1 - Day Float MTD',
    '083': 'Average 1 - Day Float YTD',
    '084': 'Average 2 - Day Float MTD',
    '085': 'Average 2 - Day Float YTD',
    '086': 'Transfer Calculation',
    '087': 'Target Balance Deficiency',
    '088': 'Total Funding Requirement',
    '119': 'Count of EDI Credit Transactions',
    '134': 'Count of Concentration Credits',
    '141': 'Count of ACH Credits',
    '154': 'Count Preauthorized Payment Credits',
    '161': 'Count of Corporate Trade ACH Pay Credit',
    '192': 'Count of Total Incoming Money Transfers',
    '203': 'Count of Book Transfer Credits',
    '204': 'Count of Total International Money Transfer',
    '279': 'Count of Total Control Disbursement Credits',
    '419': 'Count of EDI Transaction Debit',
    '448': 'Count of ACH Disbursement Funding Debits',
    '492': 'Count of Wire Transfer Debits',
    '503': 'Count of Book Transfer Debit',
    '517': 'Total # of International Wire Transfers',
    '571': 'Count of Disbursing Check Paid-Early',
    '573': 'Count of Disbursing Check Paid Late',
    '589': 'Count of Later Debits After Notification',
    '701': 'Principle Loan Balance',
    '703': 'Available Commitment Amount',
    '705': 'Payment Amount Due',
    '707': 'Principle Amount Past Due',
    '709': 'Interest Amount Past Due',
    '900': 'Total Universal Credits',
    '901': 'Adjusted Closing Balance',
    '906': "Today's Opening 1 Day Float",
    '907': "Today's Opening 2 Day Float",
    '910': 'Investment Opening Position',
    '911': 'Current Dividend Rate',
    '912': 'Month-to-Date Accrued',
    '913': 'YTD Dividend Paid',
    '914': 'Previous Year Dividend Paid',
    '915': 'DDA Opening Available Balance',
    '920': 'Total Universal Credits',
};
